import { LOCATIONS } from '../../constants';

export function storeName(location) {
    return LOCATIONS[location] ?? location;
}

export function storeList(locations = []) {
    return locations.map(storeName).join(', ');
}

export function scopeLabel(t, scope) {
    if (scope === 'all') return t('inventoryCheck.review.scopeAll');
    return t('inventoryCheck.review.scopeCategory', {
        category: scope === '' ? t('inventoryCheck.noCategory') : scope,
    });
}

export function priceLabel(t, price) {
    if (price == null) return t('inventoryCheck.review.notRecorded');
    return Number(price).toLocaleString('en-US', {
        style: 'currency', currency: 'USD', maximumFractionDigits: 0,
    });
}

export function weightLabel(t, weight) {
    if (weight == null) return t('inventoryCheck.review.notRecorded');
    return t('inventoryCheck.review.gramsSuffix', { weight: Number(weight).toFixed(1) });
}

export function metalLabel(t, metal) {
    if (!metal) return t('inventoryCheck.review.notRecorded');
    return metal;
}
